import Navigation from "@/components/Navigation";
import AgentsOrbit from "@/components/AgentsOrbit";
import AiStats from "@/components/AiStats";
import AiProcess from "@/components/AiProcess";
import KiOutputs from "@/components/KiOutputs";
import CreativeWorkspace from "@/components/CreativeWorkspace";
import Footer from "@/components/Footer";
import Chatbot from "@/components/Chatbot";
import SEOHead from "@/components/SEOHead";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

const KiLoesungenPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen">
      <SEOHead
        title="KI Lösungen für dein Business — Freys Media & Freycreate.ai"
        description="KI-gestütztes Marketing & Content: Freycreate.ai für Bilder, Videos und Logos · KI-Agenten für Workflow-Automatisierung. Aus Villingen-Schwenningen."
        canonicalUrl="https://freysmedia.de/ki-loesungen"
      />
      <Navigation />
      <div className="pt-24 pb-4 container mx-auto px-4 sm:px-6 lg:px-8">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-muted-foreground hover:text-white transition-colors text-sm"
        >
          <ArrowLeft className="w-4 h-4" /> Zur Startseite
        </button>
      </div>
      <AgentsOrbit />
      <AiStats />
      <AiProcess />
      <KiOutputs />
      <CreativeWorkspace />
      <Footer />
      <Chatbot />
    </div>
  );
};

export default KiLoesungenPage;
